// File: js/shared/extensions/dynamicBlocks-create.js
//
// Initialization-only module for dynamic-block sections (mixed media:
// text / image / audio / video / podcast / module child references).
//
// All click/change handling lives in `blockEventBus.js` (delegated globally,
// bound once). This file only:
//   - registers the dynamic-block factory used by the bus in upload mode
//   - imports the bus so it self-inits on first page load
//   - hydrates per-block listeners that have to be per-block by nature
//     (richtext sync, media preview, drag-and-drop, podcast/module selects)
//
// Idempotent — safe to call any number of times. The per-block helpers each
// have their own dataset guards.

import { setupRichtextSync } from '../utils/richtextUtils.js';
import { createDynamicBlock } from '../utils/blockFactory.js';
import { setupMediaPreview, setupDragAndDrop } from '../utils/mediaUtils.js';
import { setupPodcastBlockListeners } from '../utils/podcastUtils.js';
import { register } from '../events/blockFactoryRegistry.js';
import '../events/blockEventBus.js';

register('mixed', (_section, blockName, type, index) => {
  return createDynamicBlock(blockName, type, index);
});

export function setupDynamicBlocks() {
  document.querySelectorAll('section.dynamic-blocks').forEach(section => {
    const container = section.querySelector('.blocks-container');
    if (!container) return;

    container.querySelectorAll('.block').forEach(block => {
      const type = block.dataset.type;
      if (type === 'text') {
        setupRichtextSync(block);
      } else if (type === 'podcast') {
        // Podcast list population is container-scoped; called once per section.
      } else {
        setupMediaPreview(block);
        setupDragAndDrop(block);
      }
    });

    // Container-scoped: populates podcast/module child selects on existing
    // blocks. Each helper short-circuits when the select is already populated.
    setupPodcastBlockListeners(container);
  });
}
